import { useContext } from 'react';
import {
    Table, TableBody, TableCell,
    TableHead, TableRow, TableFooter, Typography
} from '@material-ui/core';
import { DeleteIconButton, EditIconButton } from 'components';
import { ticketStatusesContext } from '../TicketStatusesContext';
import { Check } from '@material-ui/icons';



let Results = () => {
    let service = useContext(ticketStatusesContext);

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Code</TableCell>
                        <TableCell>Videndum status</TableCell>
                        <TableCell>Customer status</TableCell>
                        <TableCell>Is initial status</TableCell>
                        <TableCell>Is resolved</TableCell>
                        <TableCell>Has automatic updates</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.statuses.map((status, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{status.code}</TableCell>
                            <TableCell>{status.name}</TableCell>
                            <TableCell>{status.customerVisibleStatus}</TableCell>
                            <TableCell>{status.isInitialStatus && <Check />}</TableCell>
                            <TableCell>{status.isResolved && <Check />}</TableCell>
                            <TableCell>{status.hasAutomaticUpdates && <Check />}</TableCell>
                            <TableCell align="right">
                                <EditIconButton link={`/admin/ticketstatus/${status.id}`} />
                                <DeleteIconButton onClick={() => service.deleteTicketStatus(status.id)} stopPropagation />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.statuses.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}>
                                <Typography variant="subtitle2">No ticket statuses found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </>
    );
}

export default Results;

